import type { TemplateCollection } from "../types";

/**
 * Recursively extracts all formInput field IDs from a template collection.
 * Walks through nested templates (e.g., fieldSet, formRowGroup) to find all input fields.
 */
export const extractFieldIDs = ({
  templates,
}: {
  templates?: TemplateCollection;
}): string[] => {
  if (!templates) return [];

  const ids: string[] = [];

  const traverse = (templateCollection: TemplateCollection) => {
    for (const template of templateCollection) {
      if (template.templateKey === "formInput") {
        const fieldID =
          typeof template.data?.id === "string"
            ? template.data.id
            : template.id;
        if (fieldID) {
          ids.push(fieldID);
        }
      }
      // Recursively check nested templates in data.templates
      if (template.data?.templates) {
        traverse(template.data.templates);
      }
    }
  };

  traverse(templates);
  return ids;
};
